<template>
    <div v-loading="loading || (fsspCheck && fsspCheck.status === 0)">
        <div class="mb-1" v-if="error_messages.length"><div class="text-danger small" v-for="e in error_messages">{{e}}</div></div>
        <template v-if="!fsspCheck">
            <button :disabled="loading || !$hasPermission('requests.fssp_check.create')" @click="createCheck" class="btn btn-primary">Запросить данные у ФССП</button>
        </template>
        <template v-else>
            <template v-if="fsspCheck && fsspCheck.status === -1">
                <div class="text-danger">Завершено с ошибками. Данные могут быть неполными. <a :disabled="loading || !$hasPermission('requests.fssp_check.create')" @click="createCheck" style="text-decoration-line: underline; font-weight: bold">Запросить данные у ФССП</a></div>
            </template>
<!--            <template v-if="fsspCheck.status === 0">-->
<!--                Процесс идет-->
<!--            </template>-->
<!--            <template v-if="fsspCheck.status === -1 || fsspCheck.status === 0">-->
<!--                <div class="mb-3"><el-progress :percentage="percentage" :status="fsspCheck.status === -1 ? 'exception' : null"></el-progress></div>-->
<!--            </template>-->
            <template>
                <table class="table table-sm mb-0" v-loading="loadingProductions">
                    <tbody>
                    <tr>
                        <td class="font-weight-bold">Итого задолженность</td>
                        <td class="px-2" :class="{'table-danger': debt_amount > 0, 'table-success': debt_amount === 0}"><span class="text-nowrap">{{debt_amount}} руб</span></td>
                    </tr>
                    <template v-for="prod in productions">
                        <tr>
                            <td>{{prod.subject}}</td>
                            <td class="px-2"><span class="text-nowrap" v-if="prod.amount">{{prod.amount}} руб</span></td>
                        </tr>
                    </template>
                    <tr v-if="fsspCheck && fsspCheck.status === 1">
                        <td colspan="3" class="text-center">
                            <el-popconfirm
                                title="Все полученные данные от ФССП будут утеряны и запрошены заново. Продолжить?"
                                confirm-button-text="Продолжить"
                                cancel-button-text="Отмена"
                                @confirm="createCheck"
                            >
                                <button :disabled="loading || !$hasPermission('requests.fssp_check.create')" slot="reference" class="btn btn-link btn-sm"><i class="fas fa-redo"></i> Перезапросить данные у ФССП</button>
                            </el-popconfirm>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: "RequestFsspBlock",
    props: ['request_id'],
    data: () => ({
        fsspCheck: null,
        fsspProductions: [],

        error_messages: [],
        loading: false,
        loadingProductions: false,
    }),
    mounted() {
        this.fetchFsspCheck();
        this.fetchFsspProductions();
        this.socketConnect(this.request_id);
    },
    beforeDestroy() {
        this.fsspCheck = null;
        this.fsspProductions = [];
        this.socketDisconnect(this.request_id);
    },
    watch: {
        request_id: function (val, oldVal) {
            this.fsspCheck = null;
            this.fsspProductions = [];
            this.socketDisconnect(oldVal);
            this.socketConnect(val);
        },
    },
    computed: {
        productions() {
            return this.fsspProductions
                .sort((a, b) => {
                    return a.id - b.id;
                })
                .filter(prod => {
                    return !prod.end || !prod.end.length;
                })
        },
        debt_amount() {
            return parseFloat(_.sumBy(this.productions, prod => {
                return prod.amount;
            }).toFixed(2));
        },
        percentage() {
            let v = 0;
            if (this.fsspCheck && this.fsspCheck.jobs_count > 0) {
                v = Math.round(this.fsspCheck.jobs_completed / this.fsspCheck.jobs_count * 100);
                if (v > 100) v = 100;
            }
            return v;
        }
    },
    methods: {
        socketConnect(id) {
            let self = this;
            Echo.private(`request.${id}`)
                .listen('.request.updated_fssp_check', function (e) {
                    setTimeout(() => {
                        console.log(e.fssp_check);
                        self.fsspCheck = e.fssp_check;
                    }, Math.random() * 300)
                })
                .listen('.request.created_fssp_production', function (e) {
                    self.fsspProductions.push(e.fssp_production);
                })
                .listen('.request.deleted_fssp_productions', function (e) {
                    self.fsspProductions = [];
                });
        },
        socketDisconnect(id) {
            Echo.leave(`request.${id}`);
        },
        createCheck() {
            this.error_messages = [];
            let self = this;
            this.loading = true;
            axios.post('/api/fssp/create_check', {request_id: this.request_id})
                .then(response => {
                    self.fsspCheck = response.data;
                    self.loading = false;
                })
                .catch(error => {
                    if (error.response.data && error.response.data.errors) {
                        _.forEach(error.response.data.errors, item => {
                            _.forEach(item, i => {
                                self.error_messages.push(i)
                            })
                        })
                    } else if (error.response.data.message) {
                        self.error_messages.push(error.response.data.message)
                    } else {
                        self.error_messages.push('что-то пошло не так')
                    }
                    self.loading = false;
                });
        },
        fetchFsspCheck() {
            let self = this;
            this.loading = true;
            axios.get('/api/requests/' + this.request_id + '/fssp_check')
                .then(response => {
                    self.fsspCheck = response.data;
                    self.loading = false;
                });
        },
        fetchFsspProductions() {
            let self = this;
            this.loadingProductions = true;
            axios.get('/api/requests/' + this.request_id + '/fssp_productions')
                .then(response => {
                    self.fsspProductions = response.data;
                    self.loadingProductions = false;
                });
        }
    }
}
</script>

<style scoped>

</style>
